import { Popup } from './_popup.js';

(function () {
	const popup_els = document.getElementsByClassName(`popup`);
	if (popup_els.length === 0) {
		return;
	}

	for (let i = 0; i < popup_els.length; i++) {
		const popup = new Popup(popup_els[i]);

		window.sh_popups[popup.id] = popup;
	}
})();
